/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ng2-translate/src/translate.pipe';
import * as import2 from 'ng2-translate/src/translate.service';
import * as import3 from '../../../html-utils/html.pipe';
import * as import4 from '@angular/platform-browser';
import * as import5 from '../../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import6 from '../../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import7 from '../../../orchestration/page';
import * as import8 from '../../../orchestration/navigation.service';
import * as import9 from '@angular/common';
import * as import10 from './options-page.component';
import * as import11 from '../../../orchestration/navigation-params';
const styles_OptionsPageComponent:any[] = ([] as any[]);
export const RenderType_OptionsPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_OptionsPageComponent,
  data: {}
}
);
function View_OptionsPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'options-option none'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectOption((null as any))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '',
      ''
    ]
    )),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    )
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,import0.ɵnov(v,2).transform('woa.label.common.none'));
    ck(v,1,0,currVal_0);
  });
}
function View_OptionsPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'options-option'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
      ],[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectOption(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵpod(['value']),
    import0.ɵpid(131072,import1.TranslatePipe,[
      import2.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,3,0,import0.ɵnov((<any>v.parent),0),(v.context.$implicit.label? import0.ɵunv(v,0,0,import0.ɵnov(v,2).transform(v.context.$implicit.label,ck(v,1,0,v.context.$implicit.value))): v.context.$implicit.value)));
    ck(v,0,0,currVal_0);
  });
}
export function View_OptionsPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import3.HtmlPipe,[import4.DomSanitizer]),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),11,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import5.View_ModalPageLayoutComponent_0,import5.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import6.ModalPageLayoutComponent,[
      import7.Page,
      import8.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,2,{contentMessages: 1}),
    import0.ɵqud(603979776,3,{footerControls: 1}),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import7.PageLayout,(null as any),[import6.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OptionsPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import9.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_OptionsPageComponent_2)),
    import0.ɵdid(802816,(null as any),0,import9.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.OptionsPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = co.translationParams;
    ck(v,3,0,currVal_0,currVal_1);
    const currVal_2:any = co.showNone;
    ck(v,9,0,currVal_2);
    const currVal_3:any = co.options;
    ck(v,12,0,currVal_3);
  },(null as any));
}
function View_OptionsPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-options-page',([] as any[]),(null as any),(null as any),(null as any),View_OptionsPageComponent_0,RenderType_OptionsPageComponent)),
    import0.ɵdid(49152,(null as any),0,import10.OptionsPageComponent,[
      import11.NavigationParams,
      import8.NavigationService
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import7.Page,(null as any),[import10.OptionsPageComponent])
  ]
  ,(null as any),(null as any));
}
export const OptionsPageComponentNgFactory:import0.ComponentFactory<import10.OptionsPageComponent> = import0.ɵccf('woa-options-page',import10.OptionsPageComponent,View_OptionsPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/inputs/selection-field/options-page/options-page.component.ngfactory.ts